// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import PhotoOutline from '../_raw/ui/icon_Photo_Outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(PhotoOutline);
